import { ACTIONS } from '_redux/actions';
import { get } from './api';

export function fetchMedia(params) {
  return get('submissions',
    params,
    ACTIONS.MEDIA.FETCH_MEDIA,
    ACTIONS.MEDIA.FETCH_MEDIA_SUCCESS,
    ACTIONS.MEDIA.FETCH_MEDIA_ERROR,
    false);
}
